import { EntityTypeEnum } from "../../enums/entity-type-id-enum";
import { FileBaseModel } from "./file-base-model";

export class EntityFileModel extends FileBaseModel {
    entityId?: string;
    entityTypeId?:EntityTypeEnum;
    isIcon: boolean = true;
    tags?: string[] = [];
}
